"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import InterCustomerSlider from "../InterCustomerSlider";
import { GlobalAttractive as Icon_GlobalAttractive } from "@/components/customer/icons/GlobalAttractive";
import { GlobalFastIntegration as Icon_GlobalFastIntegration } from "@/components/customer/icons/GlobalFastIntegration";
import { GlobalMultilingual as Icon_GlobalMultilingual } from "@/components/customer/icons/GlobalMultilingual";
import { GlobalRealTime as Icon_GlobalRealTime } from "@/components/customer/icons/GlobalRealTime";
import { GlobalWhiteLabel as Icon_GlobalWhiteLabel } from "@/components/customer/icons/GlobalWhiteLabel";
import { Globalproduct as Icon_Globalproduct } from "@/components/customer/icons/Globalproduct";
const SvgIcons = { GlobalAttractive: Icon_GlobalAttractive, GlobalFastIntegration: Icon_GlobalFastIntegration, GlobalMultilingual: Icon_GlobalMultilingual, GlobalRealTime: Icon_GlobalRealTime, GlobalWhiteLabel: Icon_GlobalWhiteLabel, Globalproduct: Icon_Globalproduct };
import FaqSection from "../FaqSection";
import { partnersFaqs } from "@/app/partners/faq";
import GlobalPartnersCount from "@/components/GlobalPartnersCount";
import logo1 from "@/components/images/Partners/Logo Blue.svg";
import logo2 from "@/components/images/Partners/Global Freelancers Festival 2026 1.svg";
import { getImageUrl } from "@/lib/imageUrl";



// ─────────────────────────────────────────────
// Utility
// ─────────────────────────────────────────────
function hexToRgb(hex: string): string {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return r
    ? `${parseInt(r[1], 16)},${parseInt(r[2], 16)},${parseInt(r[3], 16)}`
    : "0,0,0";
}

// ─────────────────────────────────────────────
// Countdown Hook
// ─────────────────────────────────────────────
function useCountdown(target: string) {
  const calc = () => {
    const diff = new Date(target).getTime() - Date.now();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff % 86400000) / 3600000),
      m: Math.floor((diff % 3600000) / 60000),
      s: Math.floor((diff % 60000) / 1000),
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, [target]);
  return time;
}


const productImages1 = getImageUrl(
    "/vilvabusiness/website/common/homepage/vilvad2cp_1.webp"
  );

  const productImages2 = getImageUrl(
    "/vilvabusiness/website/common/homepage/vilvawhatsease_1.webp"
  );

  const productImages3 = getImageUrl(
    "/vilvabusiness/website/common/homepage/vilvaone_1_1.webp"
  );
  const productImages4 = getImageUrl(
    "/vilvabusiness/website/common/homepage/wapro_1.webp"
  );

   const productImages5 = getImageUrl(
    "/vilvabusiness/website/common/homepage/pushwault_1.webp"
  );

  const productImages6 = getImageUrl(
    "/vilvabusiness/website/common/homepage/growsuit_1.webp"
  );

  const productImages7 = getImageUrl(
    "/vilvabusiness/website/common/homepage/verify_api_1.webp"
  );

  
  const productImages8 = getImageUrl(
    "/vilvabusiness/website/common/homepage/busbooking_1.webp"
  );

// ─────────────────────────────────────────────
// Section-D: Product data
// ─────────────────────────────────────────────
const PRODUCTS = [
  {
    id: "vilva-erp",
    name: "Vilva ERP",
    tagline: "Run Your Business Smarter",
    desc: "All-in-one ERP to manage operations, finance, HR, and workflows seamlessly.",
    color: "#195AFF",
    tags: ["ERP", "Operations", "Finance"],
    img: productImages7,
    href: "/growsuite",
  },
  {
    id: "online-commerce",
    name: "Online Commerce",
    tagline: "Sell Anywhere, Anytime",
    desc: "Launch scalable eCommerce platforms with secure payments and automation.",
    color: "#F59E0B",
    tags: ["E-Commerce", "Payments", "Automation"],
    img: productImages1,
    href: "/d2c-e-commerce-platform-for-growth-stage-businesses",
  },
  {
    id: "business-websites",
    name: "Business Websites",
    tagline: "Build a Powerful Digital Presence",
    desc: "High-performance websites designed for credibility, conversion, and growth.",
    color: "#6366F1",
    tags: ["Web Design", "Conversion", "Growth"],
    img: productImages3,
    href: "/business-websites",
  },
  {
    id: "Digital-marketing",
    name: "Digital Marketing",
    tagline: "Turn Attention into Revenue",
    desc: "Creative branding, campaign design, and digital visibility strategies.",
    color: "#EC4899",
    tags: ["Branding", "Campaigns", "Design"],
    img: productImages4,
    href: "/digital-marketing",
  },
  {
    id: "vilva-chat",
    name: "Vilva Chat",
    tagline: "Automate Conversations & Sales",
    desc: "Smart WhatsApp and chat automation to convert leads into customers.",
    color: "#25D366",
    tags: ["WhatsApp", "Chat", "Automation"],
    img: productImages2,
    href: "/vilvachat-official-whatsapp-business-api",
  },
  {
    id: "integrated-growth",
    name: "Integrated Growth Ecosystem",
    tagline: "One Unified Digital Growth Stack",
    desc: "ERP + Commerce + Marketing + Automation working together as one system.",
    color: "#10B981",
    tags: ["Ecosystem", "Integration", "Growth"],
    img: productImages8,
    href: "/pos",
  },
];

// ─────────────────────────────────────────────
// Section-B: Audience Cards
// ─────────────────────────────────────────────
const AUDIENCES = [
  {
    title: "Digital Agencies",
    desc: "Expand your service portfolio with white-label SaaS. Offer CRM, e-commerce, and marketing tools under your brand.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M4 26V22C4 19.8 5.8 18 8 18H24C26.2 18 28 19.8 28 22V26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="16" cy="10" r="5" stroke="currentColor" strokeWidth="2" />
        <path d="M10 13C8.34 13 7 14.34 7 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M22 13C23.66 13 25 14.34 25 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "IT Freelancers",
    desc: "Offer high-value SaaS to your clients and earn recurring commissions without building from scratch.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="4" y="6" width="24" height="18" rx="3" stroke="currentColor" strokeWidth="2" />
        <path d="M4 22H28" stroke="currentColor" strokeWidth="2" />
        <path d="M13 26H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 14L15 17L20 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Business Consultants",
    desc: "Add real tech leverage to your practice. Recommend and resell proven tools that solve your clients' core problems.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M6 26V18H12V26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 26V12H19V26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20 26V16H26V26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 26H28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Tech Entrepreneurs",
    desc: "Build your own SaaS business on Vilva's infrastructure. Go to market faster with proven, scalable B2B solutions.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16 4L20 12H28L22 18L24 26L16 21L8 26L10 18L4 12H12L16 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

// ─────────────────────────────────────────────
// Section-E: Animated SVG charts
// ─────────────────────────────────────────────
const DonutChart = ({ on }: { on: boolean }) => (
  <svg width="76" height="76" viewBox="0 0 76 76" fill="none">
    <circle cx="38" cy="38" r="26" stroke="#E0E7FF" strokeWidth="9" fill="none" />
    <circle
      cx="38" cy="38" r="26"
      stroke="#195AFF" strokeWidth="9" fill="none"
      strokeDasharray="163.4"
      strokeDashoffset={on ? "41" : "82"}
      strokeLinecap="round"
      transform="rotate(-90 38 38)"
      style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.34,1.56,0.64,1)" }}
    />
    <circle
      cx="38" cy="38" r="26"
      stroke="#31E0FF" strokeWidth="9" fill="none"
      strokeDasharray="163.4"
      strokeDashoffset={on ? "122" : "163.4"}
      strokeLinecap="round"
      transform="rotate(-90 38 38)"
      style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.34,1.56,0.64,1) 0.08s" }}
    />
  </svg>
);

const BarsChart = ({ on }: { on: boolean }) => {
  const bars = [
    { x: 2, h: 38, color: "#195AFF", delay: "0s" },
    { x: 20, h: 50, color: "#31E0FF", delay: "0.08s" },
    { x: 38, h: 30, color: "#195AFF", delay: "0.16s" },
    { x: 56, h: 44, color: "#6366F1", delay: "0.04s" },
  ];
  return (
    <svg width="76" height="56" viewBox="0 0 76 56" fill="none" overflow="visible">
      {bars.map((b, i) => (
        <g
          key={i}
          style={{
            transform: on ? "scaleY(1)" : "scaleY(0.28)",
            transformOrigin: `${b.x + 7}px 56px`,
            transition: `transform 0.65s cubic-bezier(0.34,1.56,0.64,1) ${b.delay}`,
            opacity: on ? 1 : 0.35,
          }}
        >
          <rect x={b.x} y={56 - b.h} width="14" height={b.h} rx="4" fill={b.color} />
        </g>
      ))}
      <line x1="0" y1="56" x2="76" y2="56" stroke="#D1D5DB" strokeWidth="1.5" />
    </svg>
  );
};

const TimelineChart = ({ on }: { on: boolean }) => {
  const heights = [30, 20, 36, 16, 42];
  return (
    <svg width="76" height="58" viewBox="0 0 76 58" fill="none">
      <line x1="6" y1="52" x2="70" y2="52" stroke="#D1D5DB" strokeWidth="1.5" />
      {[8, 24, 40, 56, 72].map((x, i) => (
        <g key={i}>
          <line
            x1={x} y1={on ? 52 - heights[i] : 52} x2={x} y2="52"
            stroke={on ? "#31E0FF" : "#D1D5DB"}
            strokeWidth="2.5" strokeLinecap="round"
            style={{ transition: `all 0.55s cubic-bezier(0.34,1.56,0.64,1) ${i * 0.07}s` }}
          />
          <circle
            cx={x} cy="52" r="4"
            fill={on ? "#195AFF" : "#D1D5DB"}
            style={{ transition: `fill 0.3s ease ${i * 0.07}s` }}
          />
        </g>
      ))}
    </svg>
  );
};

const LineChart = ({ on }: { on: boolean }) => {
  const pathLen = 102;
  return (
    <svg width="76" height="56" viewBox="0 0 76 56" fill="none">
      <line x1="0" y1="56" x2="76" y2="56" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="0" y1="38" x2="76" y2="38" stroke="#D1D5DB" strokeWidth="0.5" strokeDasharray="3 3" />
      <line x1="0" y1="20" x2="76" y2="20" stroke="#D1D5DB" strokeWidth="0.5" strokeDasharray="3 3" />
      <path
        d="M0 44 L15 34 L30 39 L46 21 L61 27 L76 14"
        fill="none"
        stroke="#195AFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
        strokeDasharray={pathLen}
        strokeDashoffset={on ? 0 : pathLen * 0.55}
        style={{ transition: "stroke-dashoffset 0.85s cubic-bezier(0.4,0,0.2,1)" }}
      />
      <path
        d="M0 44 L15 34 L30 39 L46 21 L61 27 L76 14 L76 56 L0 56Z"
        fill="#195AFF"
        fillOpacity={on ? 0.07 : 0.02}
        style={{ transition: "fillOpacity 0.6s ease" }}
      />
      {[[0, 44], [15, 34], [30, 39], [46, 21], [61, 27], [76, 14]].map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={on ? 3.5 : 2}
          fill={on ? "#31E0FF" : "#195AFF"}
          style={{ transition: `all 0.4s ease ${i * 0.05}s` }}
        />
      ))}
    </svg>
  );
};

const GaugeChart = ({ on }: { on: boolean }) => (
  <svg width="76" height="56" viewBox="0 0 76 56" fill="none">
    <path d="M12 54 A26 26 0 0 1 64 54" stroke="#E0E7FF" strokeWidth="8" strokeLinecap="round" fill="none" />
    <path d="M12 54 A26 26 0 0 1 64 54"
      stroke="#195AFF" strokeWidth="8" strokeLinecap="round" fill="none"
      strokeDasharray="81.7"
      strokeDashoffset={on ? "0" : "40.8"}
      style={{ transition: "stroke-dashoffset 0.85s cubic-bezier(0.34,1.56,0.64,1)" }}
    />
    <line
      x1="38" y1="54"
      x2={on ? "58" : "48"} y2={on ? "32" : "44"}
      stroke="#EC4899" strokeWidth="2.5" strokeLinecap="round"
      style={{ transition: "all 0.65s ease" }}
    />
    <circle cx="38" cy="54" r="4.5" fill="#195AFF" />
  </svg>
);

const ProgressChart = ({ on }: { on: boolean }) => {
  const rows = [
    { label: "Leads", pct: on ? 75 : 28, color: "#195AFF", delay: "0s" },
    { label: "Conv.", pct: on ? 58 : 20, color: "#31E0FF", delay: "0.1s" },
    { label: "Rev.", pct: on ? 90 : 38, color: "#10B981", delay: "0.2s" },
  ];
  return (
    <svg width="76" height="54" viewBox="0 0 76 54" fill="none">
      {rows.map((r, i) => (
        <g key={i}>
          <rect x="0" y={i * 18} width="76" height="11" rx="5.5" fill="#E5E7EB" />
          <rect x="0" y={i * 18} width={r.pct * 0.76} height="11" rx="5.5" fill={r.color}
            style={{ transition: `width 0.75s cubic-bezier(0.34,1.56,0.64,1) ${r.delay}` }}
          />
        </g>
      ))}
    </svg>
  );
};

const STAT_SVG: Record<string, React.FC<{ on: boolean }>> = {
  donut: DonutChart,
  bars: BarsChart,
  timeline: TimelineChart,
  line: LineChart,
  gauge: GaugeChart,
  progress: ProgressChart,
};

const GROWTH_STATS = [
  { title: "Global Product-Market Fit", desc: "Products validated across 50+ markets with proven retention and growth metrics.", stat: "50+", unit: "Markets", svg: "donut", Icon: SvgIcons.Globalproduct },
  { title: "Attractive Commissions", desc: "Earn generous recurring commissions — up to 40% — month after month, indefinitely.", stat: "40%", unit: "Commission", svg: "line", Icon: SvgIcons.GlobalAttractive },
  { title: "White-Label & Co-Branding", desc: "Ship fully branded SaaS under your logo in 24 hours. Full domain + UI customisation.", stat: "24h", unit: "To Launch", svg: "bars", Icon: SvgIcons.GlobalWhiteLabel },
  { title: "Real-Time Dashboard", desc: "Track sales, leads, and performance with a powerful partner analytics suite.", stat: "Live", unit: "Analytics", svg: "gauge", Icon: SvgIcons.GlobalRealTime },
  { title: "Fast Integration & Support", desc: "Get up and running quickly with a dedicated Partner Success Manager from day one.", stat: "99.9%", unit: "Uptime SLA", svg: "timeline", Icon: SvgIcons.GlobalFastIntegration },
  { title: "Multilingual Onboarding Kits", desc: "Global-ready materials, training, and support tailored for your region and language.", stat: "3x", unit: "Lead Growth", svg: "progress", Icon: SvgIcons.GlobalMultilingual },
];

// ─────────────────────────────────────────────
// Partner logos for marquee (text-based)
// ─────────────────────────────────────────────
const LOGOS = [
  "Zoho", "HubSpot", "Salesforce", "Shopify", "Stripe", "Razorpay", "Twilio",
  "SendGrid", "Freshworks", "Intercom", "Notion", "Slack", "Airtable", "Zapier",
  "Mailchimp", "Webflow", "Figma", "Mixpanel", "Segment", "Amplitude",
];

// ─────────────────────────────────────────────
// FAQs
// ─────────────────────────────────────────────


// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const PartnersPageView = () => {
  const countdown = useCountdown("2026-02-28T08:00:00");
  const eventOver = countdown.d === 0 && countdown.h === 0 && countdown.m === 0 && countdown.s === 0;

  // Section B — auto-cycling active card
  const [activeCard, setActiveCard] = useState<number | null>(null);
  const [userHovering, setUserHovering] = useState(false);
  useEffect(() => {
    if (userHovering) return;
    const id = setInterval(() => setActiveCard((p) => ((p ?? -1) + 1) % AUDIENCES.length), 2200);
    return () => clearInterval(id);
  }, [userHovering]);

  // Section D — product card hover
  const [hoveredProduct, setHoveredProduct] = useState<string | null>(null);

  // Section E — stat card hover
  const [hoveredStat, setHoveredStat] = useState<number | null>(null);

  return (
    <div className="">

      {/* ══════════════════════════════════════════════════════════
          SECTION A — GFF 2026 Event Hero Banner
      ══════════════════════════════════════════════════════════ */}
      <section className="relative bg-[linear-gradient(145deg,_#060D2E_0%,_#0D1B50_45%,_#0A2860_70%,_#050E2A_100%)] overflow-hidden">
        {/* Ambient glow orbs */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-20 -left-20 w-[360px] h-[360px] rounded-full bg-[#195AFF] opacity-[0.07] blur-[90px]" />
          <div className="absolute -bottom-16 -right-16 w-[300px] h-[300px] rounded-full bg-[#31E0FF] opacity-[0.06] blur-[80px]" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[220px] rounded-full bg-[#195AFF] opacity-[0.04] blur-[110px]" />
          {/* Subtle dot grid */}
          <div className="absolute inset-0 opacity-[0.035]"
            style={{ backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "36px 36px" }} />
        </div>

        <div className="relative z-10 md:container mx-auto px-4 py-[64px] md:py-[96px]">
         
          {/* Live badge */}
          <div className="flex justify-center mb-7">
            <span className="inline-flex items-center gap-2 bg-white/[0.08] backdrop-blur-sm border border-white/[0.15] text-white/80 font-Schibsted_Grotesk text-xs tracking-[0.28em] uppercase rounded-full px-5 py-2.5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#31E0FF] animate-pulse" />
              Partner Program
            </span>
          </div>

          {/* Partner Logos */}
          <div className="flex justify-center items-center mb-12 px-4">
            <div className="relative flex items-center justify-center gap-6 sm:gap-10">

              <Image
                src={logo1}
                alt="Vilva Business Logo"
                width={200}
                height={60}
                className="h-auto w-[120px] sm:w-[160px] md:w-[200px] object-contain"
                priority
              />
              <div className="text-[#31E0FF] h-10 flex items-center">|</div>
              <Image
                src={logo2}
                alt="Makerstribe Logo"
                width={200}
                height={60}
                className="h-auto w-[120px] sm:w-[160px] md:w-[200px] object-contain"
                priority
              />

              {/* Soft glow effect */}
              <div className="absolute inset-0 -z-10 blur-[60px] opacity-20 bg-[#195AFF] rounded-full scale-90" />
            </div>
          </div>

          {/* Title block */}
          <div className="text-center mb-10">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-[#31E0FF]/60" />
              <span className="font-NeueMontreal font-bold text-[#31E0FF] text-sm tracking-[0.35em] uppercase">Grow With Vilva Business</span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-[#31E0FF]/60" />
            </div>
            <h1 className="font-NeueMontreal font-bold text-white text-[44px] md:text-[72px] leading-[1.05] mb-5">
              Vilva Business <span className="text-[#31E0FF] font-NeueMontreal">Partner Program</span>
            </h1>
            <p className="font-Schibsted_Grotesk text-white/65 text-lg md:text-xl max-w-xl mx-auto leading-relaxed">
              White-label, resell, or refer Vilva Business solutions and earn recurring revenue — with full onboarding and support built for Indian agencies, freelancers and consultants.
            </p>
          </div>

          {/* Countdown — shown only while the event is still upcoming */}
          {!eventOver && <div className="flex justify-center gap-3 md:gap-5 mb-10">
            {[
              { v: countdown.d, l: "Days" },
              { v: countdown.h, l: "Hours" },
              { v: countdown.m, l: "Mins" },
              { v: countdown.s, l: "Secs" },
            ].map((item, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="relative w-[68px] md:w-[88px] h-[68px] md:h-[88px] rounded-[18px] bg-white/[0.08] backdrop-blur-sm border border-white/[0.14] flex items-center justify-center overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-b from-white/[0.06] to-transparent" />
                  <span className="font-NeueMontreal font-bold text-white text-[26px] md:text-[34px] tabular-nums relative z-10 leading-none">
                    {String(item.v).padStart(2, "0")}
                  </span>
                </div>
                <span className="font-Schibsted_Grotesk text-white/45 text-[10px] mt-2 tracking-[0.2em] uppercase">{item.l}</span>
              </div>
            ))}
          </div>}

          {/* Event stats row — gated on !eventOver for the same reason as the countdown above.
              The countdown already self-hid once 28 Feb 2026 passed, but this row did not, so the
              page went on advertising a date six months in the past. Both now disappear together
              the moment the event date is behind us. */}
          {!eventOver && <div className="flex flex-wrap justify-center gap-5 md:gap-10 mb-10">
            {[
              { emoji: "📅", label: "Date", value: "28 February 2026" },
              { emoji: "🕗", label: "Time", value: "8:00 AM – 6:00 PM" },
              { emoji: "📍", label: "Venue", value: "IIT Madras Research Park, Chennai" },
              { emoji: "👥", label: "Visitors", value: "25,000+ Expected" },
            ].map((s, i) => (
              <div key={i} className="flex items-center gap-3">
                <span className="text-xl leading-none">{s.emoji}</span>
                <div>
                  <div className="font-Schibsted_Grotesk text-white/40 text-[10px] uppercase tracking-wider">{s.label}</div>
                  <div className="font-NeueMontreal font-medium text-white text-sm md:text-base">{s.value}</div>
                </div>
              </div>
            ))}
          </div>}

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              href="/become-a-partner"
              className="inline-flex items-center justify-center gap-2 bg-[#195AFF] hover:bg-[#1248CC] text-white font-NeueMontreal font-medium text-base px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_8px_32px_rgba(25,90,255,0.45)] hover:-translate-y-0.5"
            >
              Become a Partner
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8H13M9 4L13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </Link>
            <Link
              href="/contact-us"
              className="inline-flex items-center justify-center gap-2 bg-white/[0.08] hover:bg-white/[0.14] backdrop-blur-sm border border-white/[0.18] text-white font-NeueMontreal font-medium text-base px-8 py-4 rounded-full transition-all duration-300"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION C — Trusted By 50+ Global Partners (Marquee)
      ══════════════════════════════════════════════════════════ */}
      <section
        data-aos="fade-up" data-aos-duration="900"
        className="py-[60px] md:py-[80px] bg-[#FAFAFA] border-y border-[#E4E9F0]"
      >
        <div className="md:container mx-auto px-4 text-center mb-10">
          <span className="font-Schibsted_Grotesk text-[#6B7280] text-xs tracking-[0.3em] uppercase">Trusted By</span>
          <h2 className="font-NeueMontreal font-bold text-[#0A0F2E] text-[28px] md:text-[38px] mt-2">
            <GlobalPartnersCount />+ Global Partners
          </h2>
        </div>

        {/* Native InterCustomerSlider with gradient masks */}
        <div className="relative overflow-hidden">
          <InterCustomerSlider />
          <div className="pointer-events-none absolute top-0 left-0 bottom-0 w-[80px] md:w-[240px] z-20"
            style={{ background: "linear-gradient(90deg, #FAFAFA 30%, rgba(250,250,250,0) 100%)" }} />
          <div className="pointer-events-none absolute top-0 right-0 bottom-0 w-[80px] md:w-[240px] z-20"
            style={{ background: "linear-gradient(270deg, #FAFAFA 30%, rgba(250,250,250,0) 100%)" }} />
        </div>


      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION D — Explore Our Products
      ══════════════════════════════════════════════════════════ */}
      <section
        data-aos="fade-up" data-aos-duration="900"
        className="py-[80px] md:py-[120px] bg-white"
      >
        <div className="md:container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="font-Schibsted_Grotesk text-[#195AFF] text-xs tracking-[0.35em] uppercase block mb-3">Product Portfolio</span>
            <h2 className="font-NeueMontreal font-bold text-[#0A0F2E] text-[34px] md:text-[52px] leading-[1.1] mb-5">
              Explore Our Products
            </h2>
            <p className="font-Schibsted_Grotesk text-[#6B7280] text-lg max-w-2xl mx-auto">
              Six powerful solutions you can resell, white-label, or integrate to build a full-stack digital business.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {PRODUCTS.map((p) => {
              const hov = hoveredProduct === p.id;
              const rgb = hexToRgb(p.color);
              return (
                <Link
                  key={p.id}
                  href={p.href}
                  className="relative block rounded-[24px] bg-white border border-[#E4E9F0] overflow-hidden"
                  style={{
                    transform: hov ? "translateY(-8px)" : "translateY(0)",
                    boxShadow: hov
                      ? `0 24px 64px rgba(0,0,0,0.09), 0 8px 20px rgba(${rgb},0.13)`
                      : "0 2px 8px rgba(0,0,0,0.04)",
                    transition: "all 0.42s cubic-bezier(0.34,1.56,0.64,1)",
                  }}
                  onMouseEnter={() => setHoveredProduct(p.id)}
                  onMouseLeave={() => setHoveredProduct(null)}
                >
                  {/* 4px top border accent */}
                  <div className="absolute top-0 left-0 right-0 h-1 rounded-t-[24px]"
                    style={{ backgroundColor: p.color, opacity: hov ? 1 : 0, transition: "opacity 0.38s ease" }} />
                  {/* 5% brand color overlay */}
                  <div className="absolute inset-0 pointer-events-none"
                    style={{ backgroundColor: p.color, opacity: hov ? 0.05 : 0, transition: "opacity 0.38s ease" }} />

                  <div className="relative z-10 p-8">
                    {/* Product image thumbnail */}
                    <div className="w-12 h-12 rounded-2xl overflow-hidden mb-5 border border-[#E4E9F0]"
                      style={{ boxShadow: hov ? `0 4px 16px rgba(${rgb},0.2)` : "none", transition: "box-shadow 0.38s ease" }}>
                      <Image src={p.img} alt={p.name} width={48} height={48} className="w-full h-full object-cover" />
                    </div>

                    {/* Tags */}
                    <div className="flex flex-wrap gap-2 mb-5">
                      {p.tags.map((t, i) => (
                        <span key={i}
                          className="font-Schibsted_Grotesk text-[11px] px-3 py-1 rounded-full border transition-all duration-300"
                          style={{
                            borderColor: hov ? p.color : "#E4E9F0",
                            color: hov ? p.color : "#6B7280",
                            backgroundColor: hov ? `${p.color}12` : "transparent",
                          }}>
                          {t}
                        </span>
                      ))}
                    </div>

                    <h3 className="font-NeueMontreal font-bold text-[#0A0F2E] text-[21px] mb-1">{p.name}</h3>
                    <p className="font-Schibsted_Grotesk text-sm text-[#6B7280] mb-3">{p.tagline}</p>
                    <p className="font-Schibsted_Grotesk text-[13px] text-[#9CA3AF] leading-relaxed">{p.desc}</p>

                    <div className="mt-6 flex items-center gap-2 font-NeueMontreal font-medium text-sm transition-all duration-300"
                      style={{ color: hov ? p.color : "#C4C9D4" }}>
                      Explore Product
                      <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                        style={{ transform: hov ? "translateX(4px)" : "translateX(0)", transition: "transform 0.3s ease" }}>
                        <path d="M3 8H13M9 4L13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION B — Who Should Visit Our Stall
      ══════════════════════════════════════════════════════════ */}
      <section
        data-aos="fade-up" data-aos-duration="900"
        className="relative py-[80px] md:py-[120px] bg-[radial-gradient(50%_50%_at_50%_50%,_#004CAF_0%,_#001F49_100%)] overflow-hidden"
      >
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-px bg-gradient-to-r from-transparent via-white/[0.15] to-transparent" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[700px] h-px bg-gradient-to-r from-transparent via-white/[0.15] to-transparent" />
        </div>

        <div className="md:container mx-auto px-4 relative z-10">
          <div className="text-center mb-14">
            <span className="font-Schibsted_Grotesk text-[#31E0FF]/70 text-xs tracking-[0.35em] uppercase block mb-3">Partner Eligibility</span>
            <h2 className="font-NeueMontreal font-bold text-white text-[34px] md:text-[52px] leading-[1.1] mb-4">
              Who Should <span className="text-[#31E0FF] font-NeueMontreal">Visit Our Stall?</span>
            </h2>
            <p className="font-Schibsted_Grotesk text-white/60 text-lg max-w-2xl mx-auto">
              Whether you&apos;re scaling an agency or launching a new venture, there&apos;s a partnership model built for your goals.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {AUDIENCES.map((item, i) => {
              const active = activeCard === i;
              return (
                <div
                  key={i}
                  className="group relative rounded-[20px] p-7 border cursor-pointer overflow-hidden transition-all duration-500"
                  style={{
                    backgroundColor: active ? "#3F92FF" : "rgba(255,255,255,0.06)",
                    borderColor: active ? "#3F92FF" : "rgba(255,255,255,0.10)",
                    boxShadow: active ? "0 20px 60px rgba(63,146,255,0.28)" : "none",
                    transform: active ? "translateY(-4px)" : "translateY(0)",
                  }}
                  onMouseEnter={() => { setUserHovering(true); setActiveCard(i); }}
                  onMouseLeave={() => setUserHovering(false)}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-white/[0.05] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                  <div
                    className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 transition-all duration-300"
                    style={{
                      backgroundColor: active ? "rgba(255,255,255,0.18)" : "rgba(255,255,255,0.10)",
                      color: active ? "#ffffff" : "#31E0FF",
                    }}
                  >
                    {item.icon}
                  </div>
                  <h3 className="font-NeueMontreal font-bold text-white text-[19px] mb-3">{item.title}</h3>
                  <p
                    className="font-Schibsted_Grotesk text-sm leading-relaxed transition-colors duration-300"
                    style={{ color: active ? "rgba(255,255,255,0.88)" : "rgba(255,255,255,0.58)" }}
                  >
                    {item.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION E — Your Global Growth Starts Here
      ══════════════════════════════════════════════════════════ */}
      <section
        data-aos="fade-up" data-aos-duration="900"
        className="py-[80px] md:py-[120px] bg-white"
      >
        <div className="md:container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="font-Schibsted_Grotesk text-[#195AFF] text-xs tracking-[0.35em] uppercase block mb-3">Why Partner With Us</span>
            <h2 className="font-NeueMontreal font-bold text-[#0A0F2E] text-[34px] md:text-[52px] leading-[1.1] mb-5">
              Your Global Growth <span className="text-[#195AFF] font-NeueMontreal">Starts Here</span>
            </h2>
            <p className="font-Schibsted_Grotesk text-[#6B7280] text-lg max-w-2xl mx-auto">
              Real advantages that compound over time — designed so your business grows faster with us than without us.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {GROWTH_STATS.map((stat, i) => {
              const on = hoveredStat === i;
              const Chart = STAT_SVG[stat.svg];
              return (
                <div
                  key={i}
                  className="rounded-[20px] p-8 cursor-default transition-colors duration-250"
                  style={{ backgroundColor: on ? "#E0E8FF" : "#F0F4FF" }}
                  onMouseEnter={() => setHoveredStat(i)}
                  onMouseLeave={() => setHoveredStat(null)}
                >
                  {/* Stat number + animated SVG chart side by side */}
                  <div className="flex items-end justify-between mb-6">
                    <div>
                      <div className="font-NeueMontreal font-bold text-[#0A0F2E] text-[38px] leading-none">{stat.stat}</div>
                      <div className="font-Schibsted_Grotesk text-[#6B7280] text-sm mt-1">{stat.unit}</div>
                    </div>
                    <div className="opacity-75">
                      <Chart on={on} />
                    </div>
                  </div>
                  <h3 className="font-NeueMontreal font-bold text-[#0A0F2E] text-[18px] mb-2">{stat.title}</h3>
                  <p className="font-Schibsted_Grotesk text-[#6B7280] text-sm leading-relaxed">{stat.desc}</p>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center mt-12">
            <Link
              href="/become-a-partner"
              className="inline-flex items-center gap-2 bg-[#195AFF] hover:bg-[#1248CC] text-white font-NeueMontreal font-medium text-base px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_8px_32px_rgba(25,90,255,0.35)] hover:-translate-y-0.5"
            >
              Get Full Details
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8H13M9 4L13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </Link>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION F — Product Cards Grid
      ══════════════════════════════════════════════════════════ */}
      <section className="md:container hidden sm:block px-4 md:px-4">
        <div className="gap-[24px] grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 w-full">
          <div className="flex flex-col items-start gap-[10px] p-[16px] flex-1 self-stretch rounded-[12px] border-[1px] border-[#C7DFFF] bg-white w-full">
            <Image alt="Vilva D2C" width={156} height={156} className="w-[40px] h-[40px] object-cover" src={productImages1} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva D2C</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Streamline your online business with our all-in-one eCommerce SaaS solution.</p>
          </div>
          <div className="flex flex-col items-start gap-[10px] p-[16px] flex-1 self-stretch rounded-[12px] border-[1px] border-[#C7DFFF] bg-white w-full">
            <Image alt="VilvaOne" width={150} height={150} className="w-[40px] h-[40px] object-cover" src={productImages3} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva One</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Book your bus tickets &amp; Order your groceries within a second.</p>
          </div>
          {/* <div className="flex flex-col items-start gap-[10px] p-[16px] w-full rounded-[12px] border-[1px] border-[#C7DFFF] bg-white">
            <Image alt="BusBooking" width={150} height={150} className="w-[40px] h-[40px] object-cover" src={BusbookingImage} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva Bus Booking</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Efficient bus ticketing and management for travel businesses.</p>
          </div> */}
          <div className="flex flex-col items-start gap-[10px] p-[16px] w-full rounded-[12px] border-[1px] border-[#C7DFFF] bg-white">
            <Image alt="GrowSuit" width={156} height={156} className="w-[40px] h-[40px] object-cover" src={productImages7} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva Growsuite</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Simplify workforce management with our all-in-one HRM solution.</p>
          </div>
          {/* <div className="flex flex-col items-start gap-[10px] p-[16px] w-full rounded-[12px] border-[1px] border-[#C7DFFF] bg-white">
            <Image alt="BusBooking" width={150} height={150} className="w-[40px] h-[40px] object-cover" src={QcommerceImage} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva Q-Commerce</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Order your groceries effortlessly with our all-in-one solution</p>
          </div> */}
        </div>
        <div className="gap-[24px] grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 w-full mt-[23px]">
          <div className="flex flex-col items-start gap-[10px] p-[16px] flex-1 self-stretch rounded-[12px] border-[1px] border-[#C7DFFF] bg-white w-full">
            <Image alt="VilvaWhatsease" width={125} height={125} className="w-[40px] h-[40px] object-cover" src={productImages2} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva Whatsease</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Securely verify users with our seamless WhatsApp OTP generator solution.</p>
          </div>
          <div className="flex flex-col items-start gap-[10px] p-[16px] flex-1 self-stretch rounded-[12px] border-[1px] border-[#C7DFFF] bg-white w-full">
            <Image alt="WaPro" width={156} height={156} className="w-[40px] h-[40px] object-cover" src={productImages4} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva Wapro</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Securely verify users with our seamless WhatsApp OTP generator solution.</p>
          </div>
          <div className="flex flex-col items-start gap-[10px] p-[16px] w-full rounded-[12px] border-[1px] border-[#C7DFFF] bg-white">
            <Image alt="Verify API" width={156} height={156} className="w-[40px] h-[40px] object-cover" src={productImages8} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Verification API</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Effortlessly verify user identities with our secure and reliable API.</p>
          </div>
          <div className="flex flex-col items-start gap-[10px] p-[16px] w-full rounded-[12px] border-[1px] border-[#C7DFFF] bg-white">
            <Image alt="Vilva Voice Bot" width={150} height={150} className="w-[40px] h-[40px] object-cover" src={productImages5} />
            <p className="text-[#090D28] text-[16px] font-semibold leading-normal font-Schibsted_Grotesk not-italic mb-[6px]">Vilva Voice Bot</p>
            <p className="text-[#727272] text-[13px] leading-[140%] font-normal font-Schibsted_Grotesk not-italic">Streamline your online business with our all-in-one eCommerce SaaS solution.</p>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          SECTION G — Partner Hero (Bottom)
      ══════════════════════════════════════════════════════════ */}
      <section
        data-aos="fade-up" data-aos-duration="900"
        className="py-[80px] md:py-[120px] md:pb-0 bg-white"
      >
        <div className="md:container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

            {/* Left — Image + floating badges */}
            <div className="relative">
              <div className="relative rounded-[28px] overflow-hidden bg-[linear-gradient(135deg,_#EBF0FF_0%,_#DBFFE7_100%)] aspect-[4/3]">
                <Image
                  src={getImageUrl("/vilvabusiness/website/common/otherallimages/our_partners_image.webp")}
                  alt="Vilva Business Partners"
                  fill
                  className="object-cover"
                  sizes="(max-width: 768px) 100vw, 50vw"
                />
                {/* Dark overlay for text contrast */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

                {/* Floating badge — earnings */}
                <div className="absolute bottom-6 left-6 bg-white rounded-2xl px-5 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.12)]">
                  <div className="font-NeueMontreal font-bold text-[#0A0F2E] text-2xl leading-none">₹2Cr+</div>
                  <div className="font-Schibsted_Grotesk text-[#6B7280] text-xs mt-0.5">Partner earnings this year</div>
                </div>

                {/* Floating badge — active partners */}
                <div className="absolute top-6 right-6 bg-white rounded-2xl px-4 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.12)]">
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse flex-shrink-0" />
                    <span className="font-Schibsted_Grotesk text-[#0A0F2E] text-sm font-medium">50+ Active Partners</span>
                  </div>
                </div>
              </div>

              {/* Ambient blob */}
              <div className="absolute -z-10 -bottom-12 -left-12 w-[220px] h-[220px] rounded-full bg-[#EBF0FF] blur-[70px]" />
            </div>

            {/* Right — Copy + CTAs */}
            <div>
              {/* Eyebrow with gradient clip */}
              <div className="inline-flex items-center gap-2.5 mb-6">
                <div className="h-px w-8 bg-[#195AFF]" />
                <span
                  className="font-NeueMontreal font-bold text-sm tracking-[0.32em] uppercase"
                  style={{
                    background: "linear-gradient(90deg, #195AFF 0%, #31E0FF 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Vilva Partner
                </span>
              </div>

              <h2 className="font-NeueMontreal font-bold text-[#0A0F2E] text-[36px] md:text-[52px] leading-[1.1] mb-6">
                Join Our Global{" "}
                <span className="text-[#195AFF] font-NeueMontreal">SaaS Ecosystem</span>
              </h2>

              <p className="font-Schibsted_Grotesk text-[#6B7280] text-lg leading-relaxed mb-8">
                Become a Vilva partner and unlock a proven revenue stream. Whether you resell, white-label, or refer clients — you earn recurring commissions, get dedicated support, and grow alongside a platform trusted by 10,000+ businesses.
              </p>

              {/* Benefits checklist */}
              <ul className="space-y-3 mb-10">
                {[
                  "Up to 40% recurring commission on every subscription",
                  "Dedicated Partner Success Manager from day one",
                  "White-label products under your brand in 24 hours",
                  "Co-marketing, webinars, and partner directory listing",
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-[#EBF0FF] flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                        <path d="M1 4L3.5 6.5L9 1" stroke="#195AFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <span className="font-Schibsted_Grotesk text-[#374151] text-base">{item}</span>
                  </li>
                ))}
              </ul>

              {/* CTA buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  href="/become-a-partner"
                  className="inline-flex items-center justify-center gap-2 bg-[#195AFF] hover:bg-[#1248CC] text-white font-NeueMontreal font-medium text-base px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_8px_32px_rgba(25,90,255,0.38)] hover:-translate-y-0.5"
                >
                  Become a Partner
                  <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8H13M9 4L13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </Link>
                <Link
                  href="/contact-us"
                  className="inline-flex items-center justify-center gap-2 border border-[#E4E9F0] hover:border-[#195AFF] text-[#0A0F2E] hover:text-[#195AFF] font-NeueMontreal font-medium text-base px-8 py-4 rounded-full transition-all duration-300 hover:bg-[#F0F5FF]"
                >
                  Talk to Our Team
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════
          FAQ Section
      ══════════════════════════════════════════════════════════ */}
      <section
        data-aos="fade-up" data-aos-duration="900"
        className="pb-[60px] md:pb-[120px] px-4 md:px-0 md:container mx-auto"
      >
        <FaqSection faqs={partnersFaqs} />
      </section>

    </div>
  );
};

export default PartnersPageView;
